import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import './Footer.css';
import { useContent } from '../../contexts/ContentContext';

const Footer: React.FC = () => {
  const { language } = useLanguage();
  const { content, isLoading } = useContent();

  if (isLoading || !content) return null;

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="social-links">
          {content.hero.socialLinks.map((link) => (
            <a
              key={link.id}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              aria-label={link.label}
            >
              <img src={link.icon} alt={link.label} className="social-icon" />
            </a>
          ))}
        </div>
      </div>

      <div className="footer-bottom">
        <p>{content.footer[language].copyright}</p>
      </div>
    </footer>
  );
};

export default Footer; 